import { eCommentReviewStatus } from "functions/api/comments/interface";

/**
 * Check if a comment matches the filter criteria and should be visible.
 *
 * @param commentFilter - The filter criteria (all, open, or resolved)
 * @param commentReviewStatus - The review status of the comment (Open, Resolved, or undefined)
 * @returns True if the comment should be visible based on the filter criteria
 */
export const isCommentVisible = (
  commentFilter: "all" | "open" | "resolved",
  commentReviewStatus?: eCommentReviewStatus,
): boolean => {
  return (
    commentFilter === "all" ||
    (commentFilter === "open" && commentReviewStatus === "Open") ||
    (commentFilter === "resolved" && commentReviewStatus === "Resolved")
  );
};
